module.exports = __webpack_public_path__ + "static/img/ex_logo_12.91f7845.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ex/ex_logo_12.jpg
// module id = p3Gw
// module chunks = 0